import { StatusBadge } from '@/components/shared/StatusBadge';

// Explicit labels for the 13 known assessment statuses (VA.2.5 activates reopened).
const STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  issued: 'Issued',
  in_progress: 'In Progress',
  submitted: 'Submitted',
  under_review: 'Under Review',
  approved: 'Approved',
  sent_back: 'Sent Back',
  returned: 'Returned',
  resubmitted: 'Resubmitted',
  reopened: 'Reopened',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
  expired: 'Expired',
};

interface AssessmentStatusChipProps {
  status: string;
  className?: string;
}

export function AssessmentStatusChip({ status, className }: AssessmentStatusChipProps) {
  const known = status in STATUS_LABELS;
  return (
    <StatusBadge
      status={known ? status : 'muted'}
      label={known ? STATUS_LABELS[status] : 'Unknown'}
      className={className}
    />
  );
}
